import { JSEncrypt } from 'jsencrypt'

import Cookies from 'js-cookie'
// cookie保存的天数
export const TOKEN_KEY = 'LOGININFO'
export const setToken = (token) => {
    Cookies.set(TOKEN_KEY, token, {expires: 0.05 || 1})
}

export const getToken = () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) return token
    else return false
}

export const browser = {
    versions:function(){
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            alipay: u.indexOf('AlipayClient') > -1, //是否支付宝
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    }(),
    language:(navigator.browserLanguage || navigator.language).toLowerCase()
};
/**
 * copyValue 复制功能
 * @param { val } val
 * @description blooean
 */
export const copyValue = function (val) {
	var cValue = val.trim();
	if (browser.versions.ios) {
		let input = document.createElement('input');
		input.style.opacity = 0;
		input.setAttribute('readonly', 'readonly');
		input.setAttribute('value', cValue);
		input.setAttribute('id', 'copyInput');
		document.body.appendChild(input);
		window.getSelection().removeAllRanges();   //将页面所有的文本区域都从选区中移除
		var range = document.createRange();   //创建一个文本区域
		var test = window.document.getElementById('copyInput');  //获取所需要复制的节点
		range.selectNode(test);   //将我们的所选节点添加到文本区域中
		window.getSelection().addRange(range);  //将文本区域添加至选区中
		if (document.execCommand('copy')) {
			document.execCommand('copy');   //执行浏览器的复制命令
			setTimeout(() => {
				document.body.removeChild(input);
				window.getSelection().removeAllRanges();
			}, 500);
			return true;
		}else{
			return false;
		}
	}else{
		let input = document.createElement('input');
		input.style.opacity = 0;
		input.setAttribute('readonly', 'readonly');
		input.setAttribute('value', cValue);
		document.body.appendChild(input);
		input.select();
		if (document.execCommand('copy')) {
			document.execCommand('copy');
			setTimeout(() => {
				document.body.removeChild(input);
			}, 500);
			return true;
		}else{
			return false;
		}
	}


};
export const decryptData = (siKey, data) => {
	let decryptMethod = new JSEncrypt();
	decryptMethod.setPrivateKey(siKey);
	let rsaPassWord = decryptMethod.decrypt(data);
	return rsaPassWord;
};
/**
 * @param {Number} str 手机号码
 * @returns {String} 处理后的字符串
 * @description 手机号码加密处理
 */
export const encyMobile = mobile => {
	var mobileAfter = mobile.substring(0, 3);
	let i = 0;
	while ((mobile.length - 7) > i) {
		i++;
		mobileAfter += '*';
	}
	mobileAfter += mobile.substring(mobile.length - 4, mobile.length);
	return mobileAfter;
}


/**
 * 压缩图片
 */

export const photoCompressMethod = function (path, obj,type, callback) {
  var img = new Image();
  img.src = path;
  img.onload = function () {
    var that = this;
    // 默认按比例压缩
    var w = that.width,
      h = that.height,
      scale = w / h;
    w = obj.width || w;
    h = obj.height || (w / scale);
    var quality = 0.7;  // 默认图片质量为0.7
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    var anw = document.createAttribute("width");
    anw.nodeValue = w;
    var anh = document.createAttribute("height");
    anh.nodeValue = h;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    ctx.drawImage(that, 0, 0, w, h);
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality);
    // 回调函数返回base64的值

    // 控制图片尺寸小于1M
    while (base64.length / 1024 > 1024) {
     quality -= 0.01;
     base64 = canvas.toDataURL("image/jpeg", quality);
    }

    callback(base64,type);
  }
};




// WEBPACK FOOTER //
// ./src/mytools/util.js